var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-c",staticStyle:{"margin-bottom":"30px"}},[_c('div',{staticClass:"success-box"},[_c('div',{staticClass:"success-title"},[_vm._v(_vm._s(_vm.i18n.success))]),_c('van-image',{attrs:{"width":"7rem","fit":"contain","src":require('assets/imgs/device2.png')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }